module.exports = __webpack_public_path__ + "static/media/band-champion.4968678d.svg";